import React from 'react';
import { useIntl } from 'react-intl';
import { StatusSelectProps } from './types';
import MultiSelect from '../../../MultiSelect';
import { MultiSelectProps } from '../../../MultiSelect/types';
import renderRadioItemWithCheckboxes from '../../../Radio/content/withCheckboxes';
import { StyledStatusSelectWrapper } from './styles';

const StatusSelect: React.FC<StatusSelectProps> = ({
  options,
  placeholder,
  label: fieldLabel,
  disabled,
  value,
  onChange,
  icon,
  renderTrigger,
}) => {
  const intl = useIntl();

  const renderSelectedItems: MultiSelectProps['renderSelectedItems'] = (
    selected
  ) =>
    renderRadioItemWithCheckboxes(
      selected,
      true,
      onChange
    )({
      label: intl.formatMessage({
        id: 'orders.orderStatus',
      }),
      value: 'status',
      checkboxes: options,
      checked: true,
    });

  return (
    <StyledStatusSelectWrapper>
      <MultiSelect
        placeholder={placeholder}
        icon={icon}
        renderTrigger={renderTrigger}
        items={[
          {
            checkboxes: options.map((o) => ({
              label: o.label,
              value: o.value,
            })),
            value: fieldLabel || 'status',
          },
        ]}
        value={{
          checkedSubItems: value,
          value: fieldLabel || 'status',
        }}
        disabled={disabled}
        renderSelectedItems={renderSelectedItems}
      />
    </StyledStatusSelectWrapper>
  );
};

export default StatusSelect;
